import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  getAnalyticsConsentStatus,
  OPEN_COOKIE_PREFERENCES_EVENT,
  setAnalyticsConsentStatus,
} from '../lib/consent';
import { ProIcon } from './ProIcon';

export const CookieBanner = () => {
  const [consentStatus, setConsentStatus] = useState(() => getAnalyticsConsentStatus());
  const [isVisible, setIsVisible] = useState(() => getAnalyticsConsentStatus() === null);

  useEffect(() => {
    const handleOpenPreferences = () => {
      setConsentStatus(getAnalyticsConsentStatus());
      setIsVisible(true);
    };

    window.addEventListener(OPEN_COOKIE_PREFERENCES_EVENT, handleOpenPreferences);
    return () => window.removeEventListener(OPEN_COOKIE_PREFERENCES_EVENT, handleOpenPreferences);
  }, []);

  const updateConsent = (nextStatus: 'granted' | 'denied') => {
    setAnalyticsConsentStatus(nextStatus);
    setConsentStatus(nextStatus);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[9998] border-t border-slate-200 bg-white/98 backdrop-blur shadow-lg shadow-slate-900/5">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="flex items-start gap-3">
            <span className="w-8 h-8 rounded-lg bg-brand-ocean/10 flex items-center justify-center text-brand-ocean shrink-0 mt-0.5">
              <ProIcon icon="cookie" family="solid" className="w-4 h-4" />
            </span>
            <p className="text-sm text-slate-600 leading-relaxed">
              <span className="sm:hidden">We use cookies for site basics and analytics.</span>
              <span className="hidden sm:inline">We use essential cookies for site function and optional analytics cookies to improve your experience.</span>
              <Link to="/privacy-policy" className="font-medium text-brand-ocean hover:underline ml-1">
                Learn more
              </Link>
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <button
              type="button"
              onClick={() => updateConsent('denied')}
              className="px-4 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
            >
              Essential only
            </button>
            <button
              type="button"
              onClick={() => updateConsent('granted')}
              className="ui-btn-primary px-4 py-2 text-sm"
            >
              Accept all
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
